import React, { FC, useMemo } from 'react';
import Select, { Props, GroupTypeBase, mergeStyles, OptionTypeBase, Styles } from 'react-select';

import theme from '@vromo/ui/components/theme';
import { sortBy } from 'lodash';
import { ObjectType } from '@vromo/api/model';

type SelectStyleType = Partial<Styles<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>>;

export const selectStyle: SelectStyleType = {
    container: (styles) => ({
        ...styles,
        position: 'relative',
        fontWeight: 'normal'
    }),
    clearIndicator: (styles) => ({
        ...styles,
        ':hover': {
            ...styles[':hover'],
            color: theme.danger
        }
    }),
    control: (styles) => ({
        ...styles,
        cursor: 'pointer',
        borderColor: theme.lightGrey,
        transition: 'border-color 150ms ease-in-out'
    }),
    multiValueLabel: (styles) => ({
        ...styles,
        padding: 6,
        fontWeight: 500
    }),
    option: (styles) => ({
        ...styles,
        cursor: 'pointer'
    }),
    placeholder: (styles) => ({
        ...styles,
        color: theme.grey
    }),
    indicatorSeparator: (styles) => ({
        ...styles,
        backgroundColor: 'transparent'
    }),
    menuPortal: (styles) => ({
        ...styles,
        zIndex: 200000
    })
};

type OptionLabel = string | number | null | undefined;

type IProps = {
    autoSort?: boolean;
    styles?: SelectStyleType;
    options: { value: OptionLabel | ObjectType; label: OptionLabel }[];
} & Omit<Props, 'options'>;

const Select2: FC<IProps> = ({ styles = {}, autoSort = true, options, ...props }) => {
    const sortedOptions = useMemo(
        () =>
            autoSort
                ? sortBy(options, ({ label }) => label?.toString().trim().toLowerCase())
                : options,
        [options, autoSort]
    );
    return (
        <Select
            options={sortedOptions}
            styles={mergeStyles(selectStyle, styles)}
            menuPosition={'absolute'}
            menuPlacement={'bottom'}
            menuPortalTarget={document.body}
            {...props}
        />
    );
};

export default Select2;
